import React from 'react';
import Breadcrumb from '../../../components/section/Breadcrumb';
import CategorySection from '../section/CategorySection';
import FooterSection from '../section/FooterSection';
import HeaderSection from '../section/HeaderSection';
import OptionSection from '../section/OptionSection';
import SubscribeSection from '../section/SubscribeSection';

export default function CategoryPage() {
    return (
        <>
            <HeaderSection />
            <Breadcrumb title="Category" />
            <CategorySection />
            <SubscribeSection />
            <OptionSection />
            <FooterSection />
        </>
    );
}
